import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  ViewChild
} from '@angular/core';

import { DropdownSingleComponent } from './components/dropdown-single.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { app_ShellService } from './app.shell.service';
import { app_OperationService } from './app.operation.service';
import { app_DatasourceService } from './app.datasource.index';
import { app_FlowService } from './app.flow.index';
import { app_FrontendFlowService } from './app.frontend.flow.service';
import { app_ReportService } from './app.report.index';
import { app_LocalizationService } from './app.localization.service';
import { app_home_ComponentContextService } from './app.home.component.context.service';
import { Language } from './localization.service';
import { JobStatus, EAssignmentMode } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { $frontendTypes} from './app.frontend.types'
import { $frontendTypes as $types} from './app.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  imports: [
    SharedModule,
  ],
  selector: 'app-home',
  templateUrl: './app.home.component.html'
})
export class app_homeComponent implements OnInit {

  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  toolbar = {
  };


  fieldsets = {
  };

  @ViewChild('dd_config') dd_config: DropdownSingleComponent;
  @ViewChild('dd_method') dd_method: DropdownSingleComponent;

  constructor(
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: app_ShellService,
private $datasources: app_DatasourceService,
private $flows: app_FlowService,
private $frontendFlows: app_FrontendFlowService,
private $reports: app_ReportService,
private $localization: app_LocalizationService,
private $operations: app_OperationService,
private $context: app_home_ComponentContextService,
) { 

  }

  ngOnInit(): void {
    this.$init();
  
  }

  initialized = false;

  async $init() {
    this.title = 'Home';
    this.initialized = true;
  }

  close() {
    this.$finish.emit();
  }

  typeValue = null;
  typeList = [
    {
      key: 6,
      name: 'Datasource'
    },
    {
      key: 9,
      name: 'Function'
    }
  ];

  async typeDisplayWithFn(value: any): Promise<string> {
    return this.typeList.find(item => item.key === value)?.name;
  }

  async typeOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    if (this.$utils.isDefinedTrimmed(filterText)) {
      return { list: this.typeList.filter(item => item.name.startsWith(filterText)), totalCount: this.typeList.length };
    } else {
      return { list: this.typeList, totalCount: this.typeList.length };
    }
  }

  typeValueChange(value) {
    this.typeValue = value;
    this.configValueChange(null);
    this.dd_config.clearListData();
  }


  configValue = null;
  config = null;
  configList = [
    {
      key: 'outbound/activate-container',
      name: 'outbound/activate-container' + ' ('+ 'MovuRobotics' +')',
      referenceName: 'execute_activate_container_request',
      appReferenceName: 'MovuRobotics',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'loadContainerId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'locationId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'warehouseId',
            type: 'number',
            isCollection: false
          },
        ]
    },
    {
      key: 'outbound/alter-pallet-hold-release',
      name: 'outbound/alter-pallet-hold-release' + ' ('+ 'MovuRobotics' +')',
      referenceName: 'execute_alter_pallet_hold_release_request',
      appReferenceName: 'MovuRobotics',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'taskId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'warehouseId',
            type: 'number',
            isCollection: false
          },
        ]
    },
    {
      key: 'outbound/change-shipment',
      name: 'outbound/change-shipment' + ' ('+ 'MovuRobotics' +')',
      referenceName: 'execute_change_shipment_request',
      appReferenceName: 'MovuRobotics',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'orderId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'shipmentId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'warehouseId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'changeContext',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'outbound/pallet-induction',
      name: 'outbound/pallet-induction' + ' ('+ 'MovuRobotics' +')',
      referenceName: 'execute_pallet_induction_request',
      appReferenceName: 'MovuRobotics',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'licensePlateId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'locationId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'warehouseId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'taskId',
            type: 'number',
            isCollection: false
          },
        ]
    },
    {
      key: 'outbound/pallet-request',
      name: 'outbound/pallet-request' + ' ('+ 'MovuRobotics' +')',
      referenceName: 'execute_pallet_request',
      appReferenceName: 'MovuRobotics',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'taskId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'warehouseId',
            type: 'number',
            isCollection: false
          },
        ]
    },
    {
      key: 'outbound/pick-request',
      name: 'outbound/pick-request' + ' ('+ 'MovuRobotics' +')',
      referenceName: 'execute_pick_request',
      appReferenceName: 'MovuRobotics',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'taskId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'warehouseId',
            type: 'number',
            isCollection: false
          },
        ]
    },
    {
      key: 'outbound/shipment-download',
      name: 'outbound/shipment-download' + ' ('+ 'MovuRobotics' +')',
      referenceName: 'execute_shipment_download_request',
      appReferenceName: 'MovuRobotics',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'orderId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'shipmentId',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'warehouseId',
            type: 'number',
            isCollection: false
          },
        ]
    },
    {
      key: 'allocation-shortage',
      name: 'allocation-shortage' + ' ('+ 'MovuRobotics' +')',
      referenceName: 'inbound_services_allocation_shortage',
      appReferenceName: 'MovuRobotics',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'order_number',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'line_number',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'item_number',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'requested_ship_quantity',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'allocation_shortage_quantity',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'shortage_reasons',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'pallet-arrival',
      name: 'pallet-arrival' + ' ('+ 'MovuRobotics' +')',
      referenceName: 'inbound_services_pallet_arrival',
      appReferenceName: 'MovuRobotics',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'pallet_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'location',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'reason_codes',
            type: 'number',
            isCollection: true
          },
        ]
    },
    {
      key: 'pick-confirmation',
      name: 'pick-confirmation' + ' ('+ 'MovuRobotics' +')',
      referenceName: 'inbound_services_pick_confirmation',
      appReferenceName: 'MovuRobotics',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'Task_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'wh_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'Srcloc',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'Pallet_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'Success',
            type: 'object',
            isCollection: false
          },
        ]
    },
    {
      key: 'storage-complete',
      name: 'storage-complete' + ' ('+ 'MovuRobotics' +')',
      referenceName: 'inbound_services_storage_complete',
      appReferenceName: 'MovuRobotics',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'pallet_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'storage_location',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'project',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'wh_id',
            type: 'string',
            isCollection: false
          },
        ]
    },
  ];

  async configDisplayWithFn(value: any): Promise<string> {
    return this.configList.find(item => item.key === value)?.name;
  }

  async configOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    let list = this.configList.filter(item => item.type === this.typeValue);
    const totalCount = list.length;
    if (this.$utils.isDefinedTrimmed(filterText)) {
      list = list.filter(item => item.name.startsWith(filterText));
    }

    return { list, totalCount };
  }
  
  configValueChange(value) {
    this.configValue = value;
    this.config = this.configList.find(item => item.key === value);
    this.methodValueChange(null);
    this.dd_method.clearListData();
  }

  get hasMethods():boolean {
    return this.config && this.config?.methods;
  }
  
  method = null;
  methodValue = null;

  async methodDisplayWithFn(value: any): Promise<string> {
    return value;
  }

  async methodOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    let list = this.config.methods;
    const totalCount = list.length;
    if (this.$utils.isDefinedTrimmed(filterText)) {
      list = list.filter(item => item.name.startsWith(filterText));
    }

    return { list, totalCount };
  }
  
  methodValueChange(value) {
    this.methodValue = value;
    this.result = null;    
    if (this.hasMethods) {
      this.method = this.config.methods.find(item => item.key === value);
    } else {
      this.method = null;
    }
    this.onInParamChanged();
  }


  get inParams() {
    if (this.config) {
      if (this.config.methods) {
        if (this.method) {
          return this.method.inParams;
        }
      } else {
        return this.config.inParams;
      }
    }
    return null;
  }

  previewInParams = null;
  onInParamChanged() {
    this.previewInParams = {};
    if (this.inParams && this.inParams.length) {
      const inParams: { [key: string]: any } = {};
      this.inParams.forEach(ip => {
        inParams[ip.id] = this.evaluateValue(ip.value);
      });
      this.previewInParams = inParams;
    }
  }

  evaluateValue(value: string) {
    const val = this.$utils.isDefinedTrimmed(value) ? `(${value})` : value;
    const f = new Function(`{ return ${val} }`);
    return f();
  }

  get canExecute (): boolean {
    if (!this.config) {
      return false;
    }
    if (this.config.type === 6 && !this.methodValue) {
      return false;
    } 
    return true;
  }

  result: any;
  async run() {
    if (this.config.type === 6) {
      this.result = await this.$datasources[this.config.appReferenceName][this.config.referenceName][this.methodValue](this.previewInParams);
    } else if (this.config.type === 9) {
      this.result = await this.$flows[this.config.appReferenceName][this.config.referenceName](this.previewInParams);
    }
  }  
}
